
















import { Vue, Component, Prop, Inject } from 'vue-property-decorator';

import MonthSlotVacation from './MonthSlotVacation.vue'
import MonthSlotScheduled from './MonthSlotScheduled.vue';
import MonthSlotEmpty from './MonthSlotEmpty.vue';

import { Slot, SlotType } from '../types';
import { ISOCalendarDate } from '@/utils/date/types';
import { SlotClinic } from '@/api/calendar/backend';

@Component({
    components: {
    },
})
export default class MonthSlotDay extends Vue {
    @Prop({ default: () => [] }) slots!: Slot[]
    @Prop({ default: () => [] }) slotsClinic!: SlotClinic[]
    @Prop({ default: null }) clinic!: SlotClinic[] | null
    @Prop({ required: true }) date!: ISOCalendarDate
    @Prop({ required: true }) day!: number
    @Inject({ from: 'hasActions', default: true }) readonly hasActions!: boolean

    get clinicProp() {
        return this.clinic;
    }

    get slotComponent() {
        if (this.slots.length > 0) {
            const [slot] = this.slots;

            if (slot.type === SlotType.Vacation) {
                return MonthSlotVacation;
            }

            return MonthSlotScheduled;
        }

        return MonthSlotEmpty;
    }
}
